export default "__VITE_ASSET__BJtVz1Ak__"